// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"f7b76746","822":"486913f1"}[chunkId] + ".chunk.js";
};